import { render } from "./Leaderboard.vue?vue&type=template&id=8c1e793e"
import script from "./Leaderboard.vue?vue&type=script&lang=ts"
export * from "./Leaderboard.vue?vue&type=script&lang=ts"

import "./Leaderboard.vue?vue&type=style&index=0&id=8c1e793e&lang=scss"
script.render = render

export default script